import { useRouter } from 'next/router';
import { seoContents } from 'data/seo-content';
import SeoText from './SeoText';

const ListingSeoText = () => {
  const router = useRouter();

  const seoContent = seoContents.get(router.asPath);

  if (!seoContent) return <></>;

  return <SeoText content={seoContent} key={router.asPath} />;
};

export default ListingSeoText;
